export const AsMonsterToElement =  ()=>{
    return (
        <div className="container">
            移動した後に、格納される<a href="/tcgcreatoreternalbetaver2/card_variable">カード変数</a>を表します
            <p><img src={`${process.env.PUBLIC_URL}/dialogbox_as_monster_to.png`}></img></p>
            上記例ではkokaという<a href="/tcgcreatoreternalbetaver2/card_variable">カード変数</a>に移動したカードが格納されます
        </div>
    )
}
